module.exports = __webpack_public_path__ + "img/Acura.69559bab.png";